'use client';

import * as React from 'react';
import { motion, useInView } from 'motion/react';
import { useTranslation } from 'react-i18next';

export function TypingEffect() {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true });
  const { t } = useTranslation('app');

  return (
    <h2
      ref={ref}
      className="text-center text-lg font-bold tracking-tighter sm:text-3xl md:text-4xl md:leading-[4rem] text-base-content"
    >
      {t('loading')
        .split('')
        .map((letter, index) => (
          <motion.span
            key={index}
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : {}}
            transition={{ duration: 0.2, delay: index * 0.1 }}
          >
            {letter}
          </motion.span>
        ))}
    </h2>
  );
}
